import { v4 as uuidv4 } from 'uuid';
import { Base64 } from 'js-base64';
import moment from 'moment';
moment.locale('zh_cn');
import _ from "underscore";
import axios from 'axios';
import { Modal, message } from "ant-design-vue";
import Decimal from 'decimal.js';
import JSZip from 'jszip';
import FileSaver from 'file-saver';
import store from './store';
import PDFMerger from 'pdf-merger-js/browser';
import { copyText } from "vue3-clipboard";

function sliceFile(size) {
  let chunksize = 512 * 1024;//切片大小 512k
  let res = [];
  if (size <= chunksize) {
    res.push({ chunk: 0, chunks: 1 });
  } else {
    let chunks = size % chunksize == 0 ? Math.floor(size / chunksize) : Math.floor(size / chunksize) + 1;
    for (let i = 0; i < chunks; i++) {
      res.push({ chunk: i, chunks, from: chunksize * i, to: (i == chunks - 1) ? size : chunksize * (i + 1) });
    }
  }
  return res;
}
function makeUUID() {
  return uuidv4().replace(/-/g, '');
}
function dateFormat(date, pattern) {
  if (!date) date = Date.now();
  if (!pattern && typeof date === "string") {
    pattern = date;
    date = Date.now();
  }
  pattern = typeof pattern === 'string' ? pattern : 'YYYY-MM-DD';
  let day = moment(date);
  if (day.isValid()) return day.locale('zh_cn').format(pattern);
  return "";
}
function fromNow(date) {
  return moment(date).fromNow();
}
function callPhone(phone) {
  let a = document.createElement("a"), //创建a标签
    e = document.createEvent("MouseEvents"); //创建鼠标事件对象
  e.initEvent("click", false, false); //初始化事件对象
  a.href = 'tel:' + phone; //设置下载地址
  a.target = "_blank";
  a.dispatchEvent(e); //给指定的元素，执行事件click事件
}
function sleep(miliseconds = 1500) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, miliseconds);
  });
}
function toBase64String(str) {
  return Base64.encodeURI(str);
}
function shareVersion() {
  return moment().format('YYYYMMDDHHmmss');
}
function downloadBrowser({ name, href }) {
  var a = document.createElement("a"),
    e = document.createEvent("MouseEvents");
  e.initEvent("click", false, false);
  a.href = href;
  a.target = "_blank";
  if (name) a.download = encodeURIComponent(name);
  a.dispatchEvent(e);
}
function randomPassword() {
  return (Math.random() + "").substring(2, 8);
}
function alert(text) {
  return Modal.info({ title: "提示", content: text });
}
function isDecimal(n) {
  try {
    new Decimal(n);
    return true;
  } catch (e) { console.error(e) }
  return false;
}
function d(n = 0) {
  return new Decimal(n);
}
function ds(n, l = 0) {
  if (!n) return "";
  return d(n).toFixed(l);
}
function dsp(n, l = 0) {
  if (!n) return "";
  let v = d(n).times(100).toFixed(l);
  if (v === 'NaN') return '-';
  return v + '%';
}
function textToColor(str) {
  if (!str || str.length === 0)
    return false;
  for (var i = 0, hash = 0; i < str.length; hash = str.charCodeAt(i++) + ((hash << 5) - hash));
  for (var j = 0, color = '#'; j < 3; color += ('00' + ((hash >> j++ * 2) & 0xFF).toString(16)).slice(-2));
  return color;
}
async function setStore({ userid, username, name, role, utype }) {
  localStorage.setItem("zbsc_admin.userid", userid);
  localStorage.setItem("zbsc_admin.username", username);
  localStorage.setItem("zbsc_admin.name", name);
  localStorage.setItem("zbsc_admin.role", role);
  localStorage.setItem("zbsc_admin.utype", utype);
  await store.dispatch("user/setUser", { userid, username, name, role, utype });
}
function formatMoney(number, places, symbol, thousand, decimal) {
  number = Number(number) || 0;
  places = !isNaN(places = Math.abs(places)) ? places : 0;
  symbol = symbol !== undefined ? symbol : "￥";
  thousand = thousand || ",";
  decimal = decimal || ".";
  var negative = number < 0 ? "-" : "";
  var i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
    j = (j = i.length) > 3 ? j % 3 : 0;
  return symbol + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : "");
}
function getBuffer(url) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url,
      responseType: 'arraybuffer'
    }).then(data => {
      resolve(data.data);
    }).catch(error => {
      console.error(error);
      resolve(null);
    })
  })
}
function getBlob(url) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url,
      responseType: 'blob'
    }).then(data => {
      resolve(data.data);
    }).catch(error => {
      console.error(error);
      resolve(null);
    })
  })
}
function saveBlob(blob, name) {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, name);
    message.destroy();
    message.success("下载完成");
  } else {
    const link = document.createElement('a');
    const body = document.querySelector('body');
    link.href = window.URL.createObjectURL(blob); // 创建对象url
    link.download = name;
    // fix Firefox
    link.style.display = 'none';
    body.appendChild(link);
    link.click();
    body.removeChild(link);
    window.URL.revokeObjectURL(link.href); // 通过调用 URL.createObjectURL() 创建的 URL 对象
    message.destroy();
    message.success("下载完成");
  }
}
function download(url, name = '') {
  message.loading("正在下载", 0);
  getBlob(url).then((blob) => {
    saveBlob(blob, name);
  }).catch(() => {
    message.destroy();
    message.fail("下载失败");
  });
}
/**
 * 批量打包zip包下载
 * @param files Array [{url: 下载文件的路径, name: 下载文件名称}]
 * @param zipname zip文件名
 */
function downloadZip(files, zipname) {
  zipname = zipname || "打包下载";
  if (files.length === 0) return;
  if (files.length === 1) return download(files[0].url, files[0].name);
  message.loading("正在下载", 0);
  const zip = new JSZip();
  const cache = {};
  const promises = [];
  files.forEach((item) => {
    const promise = getBlob(item.url).then((data) => { // 下载文件, 并存成ArrayBuffer对象
      zip.file(item.name, data, { binary: true }) // 逐个添加文件
      cache[item.name] = data
    })
    promises.push(promise);
  });

  Promise.all(promises).then(() => {
    zip.generateAsync({ type: 'blob' }).then((content) => { // 生成二进制流
      FileSaver.saveAs(content, `${zipname}.zip`); // 利用file-saver保存文件
      message.success("下载完成");
    });
  });
}
async function mergePDF(urls) {
  message.loading("正在下载", 0);
  const merger = new PDFMerger();
  const files = await Promise.all(_.map(urls, n => getBlob(n)));
  console.log(files);
  for (let i = 0; i < files.length; i++) {
    await merger.add(files[i]);
  }
  const mergedPdf = await merger.saveAsBlob();
  message.destroy();
  return mergedPdf;
}
function speak(text) {
  if ("speechSynthesis" in window) {
    var synthesis = window.speechSynthesis;
    // Get the first `en` language voice in the list
    var voices = synthesis.getVoices().filter(function (voice) {
      console.log(voice);
      return voice.lang === "zh-CN";
    });
    console.log(voices);
    // Create an utterance object
    var utterance = new SpeechSynthesisUtterance(text);

    // Set utterance properties
    utterance.voice = voices[0];
    utterance.pitch = 1.5;
    utterance.rate = 1.25;
    utterance.volume = 0.8;

    // Speak the utterance
    synthesis.speak(utterance);
  } else {
    console.log("Text-to-speech not supported.");
  }
}
function sublist(list, n = 100) {
  let data = [];
  let item = [];
  for (let i = 0; i < list.length; i++) {
    item.push(list[i]);
    if (item.length === n || i === list.length - 1) {
      data.push([...item]);
      item = [];
    }
  }
  return data;
}
function sizeToText(size) {
  let b = 1;
  let k = 1024;
  let m = 1024 * k;
  if (size >= m) return d(size).dividedBy(m).toFixed(2) + 'mb';
  else if (size >= k) return d(size).dividedBy(k).toFixed(2) + 'kb';
  else if (size >= b) return size + 'b';
  return '';
}
function twidth(columns) {
  let total_width = 0;
  for (let i = 0; i < columns.length; i++) {
    let { width = 100, children } = columns[i];
    if (children?.length > 0) {
      for (let j = 0; j < children.length; j++) {
        let { width = 100 } = children[j];
        total_width += width;
      }
    } else {
      total_width += width;
    }
  }
  return total_width;
}
function doCopy(text) {
  copyText(text, undefined, (error, event) => {
    if (error) {
      console.log(error)
    } else {
      message.success(`复制成功：${text}`);
      console.log(event)
    }
  });
}
function filterOption(input, option) {
  console.log('filterOption', input, option);
  return option.value?.toUpperCase()?.indexOf(input.toUpperCase()) >= 0 || option.label?.toUpperCase()?.indexOf(input.toUpperCase()) >= 0;
}
function getLabel(value, options) {
  return _.findWhere(options, { value })?.label;
}
export default {
  sliceFile,
  makeUUID,
  uuid: makeUUID,
  dateFormat,
  fromNow,
  callPhone,
  toBase64String,
  downloadBrowser,
  sleep,
  randomPassword,
  shareVersion,
  alert,
  isDecimal,
  d,
  ds,
  dsp,
  moment,
  textToColor,
  setStore,
  formatMoney,
  getBlob,
  saveBlob,
  download,
  downloadZip,
  mergePDF,
  speak,
  sublist,
  sizeToText,
  twidth,
  doCopy,
  filterOption,
  getLabel,
};